import { render, staticRenderFns } from "./DidIframeListeners.vue?vue&type=template&id=6a8f70d4&scoped=true&"
import script from "./DidIframeListeners.vue?vue&type=script&lang=ts&"
export * from "./DidIframeListeners.vue?vue&type=script&lang=ts&"
import style0 from "./DidIframeListeners.vue?vue&type=style&index=0&id=6a8f70d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f70d4",
  null
  
)

export default component.exports